import { Link } from 'react-router-dom';
function MoreOptions() {
  //const [searchString,setSearchString] =useState('am');
 
    
    return (
      <main className="w-full">
     <div className="flex flex-col items-center w-full max-w-4xl mx-auto">
       <Link className='w-full p-2 m-1 text-center bg-blue-200 hover:bg-blue-600 hover:text-white' to="/about">ABOUT</Link> 
       <Link className='w-full p-2 m-1  text-center bg-blue-200 hover:bg-blue-600 hover:text-white' to="/logout">LOGOUT</Link>
       </div>
      </main>
    )
  }
  
  export default MoreOptions